import { format, isSameDay } from "date-fns";

export function computeGraph(pastSessions, graphOptions, chartData, chartOptions) {
  /* Sessions done by day across all time */

  /* Per new day, sort sessions into days */

  const uniqueDatesSegmentation = [];
  console.log("pastsessionslength ", pastSessions.length, "graphOptions: ", graphOptions)
  const testSessionDate = new Date(pastSessions[0].dateTime).valueOf();
  const graphStart = new Date(graphOptions.startDate).valueOf();
  console.log("testsessiondate:  ", testSessionDate);
  console.log("graphStart:  ", graphStart);
  for (const session of pastSessions) {
    const sessionDate = new Date(session.dateTime).valueOf();
    /* If session took place before graph start, skip, e.g. is smaller. Else if later or equal, give it a try. */
    if (sessionDate < graphStart) {
      continue;
    }

    /* Or ignore this if want to also see bookings OR only see unattended sessions */
    if (!session.timestamps || !session.timestamps.length) {
      continue;
    }


    let uniqueIDs = [];
    for (var timestamp of session.timestamps) {
      if (timestamp.UID) {
        if (!uniqueIDs.includes(timestamp.UID)) {
          uniqueIDs.push(timestamp.UID);
        }
      }
    }
    let bothAttended = false;
    if (uniqueIDs.length > 1) {
      bothAttended = true;
    }
    if (graphOptions.bothJoined && !bothAttended) {
      continue;
    }
    const found = uniqueDatesSegmentation.some((day) => isSameDay(new Date(day.date), new Date(session.dateTime)));
    if (!found) {
      console.log("made it here");
      const newDay = {
        date: session.dateTime,
        sessions: [session],
      };
      uniqueDatesSegmentation.push(newDay);
    } else {
      const index = uniqueDatesSegmentation.findIndex((day) => isSameDay(new Date(day.date), new Date(session.dateTime)));
      if (uniqueDatesSegmentation[index] && uniqueDatesSegmentation[index].sessions && uniqueDatesSegmentation[index].sessions.length) {
        uniqueDatesSegmentation[index].sessions.push(session);
      } else {
        console.log("sessions not found or index missing; index: ", index, "object at index: ", uniqueDatesSegmentation[index]);
      }
    }
  }

  /* Each number represents one datetime value, separated by commas */
  const sessionCounts = [];
  const dates = [];

  if (graphOptions.view == "1D") {
    console.log("unique dates segmentation: ", uniqueDatesSegmentation);
    if (!uniqueDatesSegmentation[0]) return console.log("required info missing");
    let sessionsForDay = uniqueDatesSegmentation[0].sessions;

    /* Sort the days sessions by hours */
    sessionsForDay = sessionsForDay.sort(function(a, b) {
      return new Date(a.dateTime) - new Date(b.dateTime);
    });

    /* Sort sessions into unique times */
    let hours = [];
    let lastSessionDate = null;
    for (const sesh of sessionsForDay) {
      if (!lastSessionDate) {
        lastSessionDate = sesh.dateTime;
        const newHour = {
          date: sesh.dateTime,
          sessions: [sesh],
        };
        hours.push(newHour);
      } else if (new Date(lastSessionDate).valueOf() == new Date(sesh.dateTime).valueOf()) {
        const index = hours.findIndex((hour) => new Date(hour.date).valueOf() == new Date(sesh.dateTime).valueOf());
        hours[index].sessions.push(sesh);
      } else {
        const newHour = {
          date: sesh.dateTime,
          sessions: [sesh],
        };
        hours.push(newHour);
        lastSessionDate = sesh.dateTime;
      }
    }

    for (const hour of hours) {
      const datetime = format(new Date(hour.date), `HH:mm`);
      dates.push(datetime);
      sessionCounts.push(hour.sessions.length);
    }
  } else {
    let sortedSegmentation = uniqueDatesSegmentation.sort(function(a, b) {
      return new Date(a.date) - new Date(b.date);
    });

    for (const day of sortedSegmentation) {
      const date = format(new Date(day.date), `MMMM d, y`);
      dates.push(date);
      sessionCounts.push(day.sessions.length);
    }
  }

  chartData.labels = dates;
  chartData.datasets[0].data = sessionCounts;
  if (graphOptions.view == "1D") {
    chartData.datasets[0].label = "Sessions done this hour";
  }

  return { chartData, options: chartOptions, graphOptions };
}
